export default {
  // 导出中心
  'EXPORT.HISTORY.TITLE': 'Export list',
  'EXPORT.INFOR.READY':
    'Export has started. An email will be sent to {email} after completion.',
  'EXPORT.HISTORY.LIST.EXPORT.TIME': 'Export time',
  'EXPORT.HISTORY.LIST.EXPORT.BY': 'Exported by',
  'EXPORT.HISTORY.LIST.STATUS.PADDING': 'Pending',
  'EXPORT.HISTORY.LIST.STATUS.SUCCESS': 'Completed',
  'EXPORT.HISTORY.LIST.STATUS.FAILED': 'Failed',
  'EXPORT.HISTORY.LIST.NUMBER.OF.CONTACTS': 'Quantity',
  'EXPORT.HISTORY.LIST.EXPORT.CONTENT': 'Export Content',
  'EXPORT.HISTORY.LIST.EXPORT.CSV': 'Export as CSV',
  'EXPORT.HISTORY.LIST.EXPORT.EXPIRED': 'Export file has expired',
  'EXPORT.HISTORY.LIST.DELETE.TITLE': 'Delete export history confirmation',
  'EXPORT.HISTORY.LIST.DELETE.CONTENT':
    'Once the export record is deleted, the data cannot be downloaded anymore.',
  'EXPORT.HISTORY.LIST.EXPORT.CONTENT.PLACEHOLDER': 'Enter export content ',
  'EXPORT.HISTORY.LIST.EXPORT.FAIL': 'Export failed, please retry.',
};
